import React from "react"
import Scrollbars from "react-custom-scrollbars-2"

import dashboardCards from "./DashboardCards"
import { SCROLLBAR, CARD, LSE_DASHBOARD_CARD } from "../../modules/constants"
import OneCard from '../../components/OneCard'
import Box from '../../components/ThemedBox'

export const Dashboard = props => {
  // console.log('props:', props)
  const { checkboxes, handleOnClick, lseApptsMeta, lseCompaniesMeta, lseEventsMeta, newsMeta, portrait } = props
  const cards = dashboardCards({ checkboxes, lseApptsMeta, lseCompaniesMeta, lseEventsMeta, newsMeta })

  return (
    <Box variant="container" id="card-container">
      {/* landscape mode, with vertical scrollbar */}
      {!portrait && <Scrollbars
        autoHide autoHideTimeout={SCROLLBAR.AH_TIMEOUT} autoHideDuration={SCROLLBAR.AH_DURATION} >
        <CardArray cards={cards} handleOnClick={handleOnClick} portrait={portrait} />
      </Scrollbars>
      }

      {/* portrait mode, without vertical scrollbar, as already scrolls in higher level div */}
      {portrait && <CardArray cards={cards} handleOnClick={handleOnClick} portrait={portrait} />}
    </Box>
  )
}

const CardArray = props => {
  // console.log('CardArray props:', props)
  const { cards, handleOnClick, portrait } = props

  return <Box
    variant="envelope"
    id="card-envelope"
    style={{
      flexDirection: portrait ? "column" : "row",
      maxWidth: portrait ? CARD.ENVELOPE.MAXWIDTH / 2 : CARD.ENVELOPE.MAXWIDTH,
      // backgroundColor: "cyan"
    }}
  >

    {/* column 1 - landscape */}
    {!portrait && <Box id="column1" style={{ width: "50%" }}>
      <OneCard id={LSE_DASHBOARD_CARD.NEWS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.ANNUAL_REPORTS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.LISTING_CHANGES} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
    </Box>}

    {/* column 2 - landscape */}
    {!portrait && <Box id="column2" style={{ width: "50%" }}>
      <OneCard id={LSE_DASHBOARD_CARD.APPOINTMENTS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.RESIGNATIONS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
    </Box>}

    {/* column 1 - portrait */}
    {portrait && <Box id="column1" style={{ width: "100%" }}>
      <OneCard id={LSE_DASHBOARD_CARD.NEWS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.APPOINTMENTS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.RESIGNATIONS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.ANNUAL_REPORTS} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
      <OneCard id={LSE_DASHBOARD_CARD.LISTING_CHANGES} cards={cards} handleOnClick={handleOnClick} portrait={portrait}></OneCard>
    </Box>}

  </Box>
}

